import {
  IWarehouse,
  IWarehouseApi,
  IWarehouseWithBags,
  IWarehouseWithBagsApi,
} from '@@/warehouses/ts';
import { bagMapper } from '@@/bags/mappers/bag.mapper';

export function warehouseMapper({
  id,
  angle,
  bags_size,
  bags_type,
  created_at,
  deleted_at,
  enter,
  filled_bags,
  marker,
  name,
  position,
  total_bags,
  total_weight,
  type,
  updated_at,
  user_id,
}: IWarehouseApi): IWarehouse {
  return {
    id,
    name,
    angle: JSON.parse(angle),
    bagsSize: bags_size,
    bagsType: Number(bags_type),
    createdAt: created_at,
    deletedAt: deleted_at,
    enter: JSON.parse(enter),
    filledBags: filled_bags,
    marker: JSON.parse(marker),
    position: JSON.parse(position),
    totalBags: total_bags,
    totalWeight: total_weight,
    type: Number(type),
    updatedAt: updated_at,
    userId: user_id,
  };
}

export function warehouseWithBagsMapper(w: IWarehouseWithBagsApi): IWarehouseWithBags {
  const wh = warehouseMapper(w);

  return {
    ...wh,
    bags: w.bags?.map(bagMapper) ?? [],
  };
}
